__turbopack_context__.v({
  "button": "MaVIsG_button",
});
